import { createSelector } from 'reselect';
import { CheckoutState } from '../reducers';

export const getPriceBreakdownState = (checkout: CheckoutState) => checkout.priceBreakdown;

export const getTotalPrice = createSelector(getPriceBreakdownState, state => state.totalPrice);
